import Axios from "axios";
import { getParameterByName } from "../getParameters";
import * as jQuery from "jquery";
import { InitializationData } from "./APIModels/models";
import {
  tournamentAPICall,
  TournamentDto,
} from "./Tournament/tournamentsAPICalls";
import { splitTextWithDash } from "../functions/Functions_General";
import { CommonData } from "../datastructures/gamestate/gameData";
// import {ga}  from "UniversalAnalytics"
import * as Sentry from "@sentry/browser";
// declare var ga: Function;

interface EndpointsDto {
  login: string;
  // game: string,
  jackpot: string;
  replay: string;
  replayRequest: string;
  balance: string;
  //pb
  interact: string;
}

interface JackpotDto {
  operator: string;
  gameReference: number;
  currency: string;
}

interface GamePlayInput {
  action: GamePlayInput.ActionEnum;
  value?: number;
}

namespace GamePlayInput {
  export type ActionEnum =
    | "BET"
    | "COLLECT"
    | "BONUS_SPIN"
    | "GAMBLE"
    | "RECOVER"
    | "SWITCH_STAKE"
    | "EXPAND_WILDS"
    | "RESPIN"
    | "EXPAND"
    | "BUY_BONUS";
  export const ActionEnum = {
    BET: "BET" as ActionEnum,
    COLLECT: "COLLECT" as ActionEnum,
    BONUS_SPIN: "BONUS_SPIN" as ActionEnum,
    GAMBLE: "GAMBLE" as ActionEnum,
    RECOVER: "RECOVER" as ActionEnum,
    SWITCH_STAKE: "SWITCH_STAKE" as ActionEnum,
    EXPAND_WILDS: "EXPAND_WILDS" as ActionEnum,
    RESPIN: "RESPIN" as ActionEnum,
    EXPAND: "EXPAND" as ActionEnum,
    BUYBONUS: "BUY_BONUS" as ActionEnum,
  };
}

export class API_Abs2 {
  private activeGameData: CommonData;
  private initUrlAfterRequest: string;
  private token: string;
  private operator: string;
  // private token: string; //token
  private endpoint: string;
  private serverAction: Array<GamePlayInput.ActionEnum>;
  private gameId: number; // ex:10002 gameRef
  private brand: string;
  private providerUrl: string;
  private endpoints: EndpointsDto;
  private jackpotURL: string;

  private loginURL: string;
  // private gameURL: string;
  private interactURL: string;
  private replayURL: string;
  private replayRequestURL: string;
  private balanceURL: string;
  // private InspectReplayURL:string;
  // private playerURL:string;
  private timeOut: number;

  private activeRoundID: number;
  private isMobile: boolean;
  private gameMode: string;
  private fakeDatas: any;
  private fakeDataIndex: number;
  private testFakeData: boolean;
  private tournamentAPICalls: tournamentAPICall;
  // private emulationData:GamePlayResult;
  constructor(game_ID: number, activeGameData: CommonData) {
    this.activeGameData = activeGameData;
    this.activeGameData;
    this.isMobile = getParameterByName("mobile") == "true";
    this.gameId = game_ID;
    this.activeRoundID = 0; //2215//2235//2215;//default
    this.activeRoundID;
    this.token = "0";

    this.serverAction = [
      "BET",
      "COLLECT",
      "GAMBLE",
      "BONUS_SPIN",
      "RECOVER",
      "SWITCH_STAKE",
      "EXPAND_WILDS",
      "RESPIN",
      "EXPAND",
      "BUY_BONUS",
    ]; //do not change index of content

    // this.setProvider("redpandastudio.com");//old
    this.timeOut = 15000;
    //---new changes for dynamic endpoint
    let isNewEndpoint = getParameterByName("newEndPoint");
    let EndPointUrl = "gaming.redpandastudio.com";
    if (isNewEndpoint == "true") {
      //build new url
      let splittedArry = splitTextWithDash(getParameterByName("brand"));
      let operator = splittedArry[0];
      let environment = splittedArry[1];
      // console.log("====",getParameterByName("brand"));
      EndPointUrl =
        "gaming." + environment + "." + operator + ".redpandastudio.com";
    }

    this.setProvider(EndPointUrl);
    //--end of new changes
    this.endpoints = {
      login: this.loginURL,
      // game: this.gameURL,
      jackpot: this.jackpotURL,
      replay: this.replayURL,
      replayRequest: this.replayRequestURL,
      // inspectReplay: this.InspectReplayURL,
      balance: this.balanceURL,

      interact: this.interactURL,
    };

    this.testFakeData = false;

    this.fakeDataIndex = 0;
    this.fakeDatas = [];
  }

  private setProvider(url: string) {
    this.providerUrl = url;
    this.setEndpoint(); //setUp the endpoint etc
    this.updateUrlId();
  }

  public setactiveRoundID = (newID: number): void => {
    this.activeRoundID = newID;
    const gamemode = getParameterByName("mode").toLowerCase();
    gamemode;
    this.replayURL = this.endpoint + `/game/game-rounds/${this.activeRoundID}`;
    // this.replayURL = this.endpoint + `/game/game-rounds/${this.activeRoundID}`

    this.endpoints["replay"] = this.replayURL;
    // console.log("===",gamemode)
  };
  private updateUrlId() {
    this.jackpotURL = this.endpoint + "/game/jackpots"; //jackpot has no demo
    this.replayURL = this.endpoint + `/game/game-rounds/${this.gameId}`;
    this.replayRequestURL = this.endpoint + `/game/game-rounds`;

    this.balanceURL = this.endpoint + "/player/balance";

    this.interactURL = this.endpoint + "/game/interact";
  }

  private testLocalHostCash = async (): Promise<void> => {
    if (window.location.host === "localhost:8080") {
      let userName = getParameterByName("devNickname");
      if (userName != null) {
        console.log("Welcome ", userName);
        let RequestUrl =
          "https://games.dev.starcasino.be/api/RedPanda/testtoken?nickname=" +
          userName;
        try {
          const response = await Axios({
            method: "get",
            url: RequestUrl,
            timeout: this.timeOut,
          });
          console.log(response.data.Token);
          this.token = response.data.Token;
        } catch (error) {
          this.token = "00000000-0000-0000-0000-000000000000";
        }
      }
    }
  };

  private setEndpoint = (): void => {
    this.brand = getParameterByName("brand");
    this.gameMode = getParameterByName("mode").toLowerCase(); //  no lowecaseNeeded
    this.token = "00000000-0000-0000-0000-000000000000";
    this.testLocalHostCash(); //use dev name to login and play cash on localhost
    let token = getParameterByName("token");
    if (token != null) {
      this.token = token;
    }
    this.loginURL =
      "https://" + this.providerUrl + "/" + this.brand + "/game/init";
    this.endpoint = "https://" + this.providerUrl + "/" + this.brand;

    ///-
    //     //     ///- MOCK SERVER TEST
    let testMockServer: boolean = false;
    if (testMockServer) {
      this.endpoint = "http://localhost:5050"; //mock server
      this.loginURL = "http://localhost:5050/game/init"; //mock server
    }

    this.tournamentAPICalls = new tournamentAPICall(this.endpoint, this.token);
  };

  errorHandle = (error: any, requestError: Function) => {
    console.log("ERROR: ", error);
    Sentry.captureException(error);
    let errorType;
    if (error.response == undefined) {
      errorType = "UNKNOWN";
      if (error.code == "ECONNABORTED") {
        errorType = "TIMEOUTERROR";
      }
      if ((error = "Error: Network Error")) {
        errorType = "networkErrorBody";
      }
    } else {
      errorType = error.response.data.errorType;
      if (errorType == undefined) {
        errorType = "UNKNOWN";
      }
    }

    requestError(errorType);
  };

  public GetBalance = (requestSuccess: Function, requestError: Function) => {
    let self = this;
    Axios({
      method: "get",
      url: this.endpoints.balance,
      data: {},
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });
  };

  //--pandorabox--------------------
  public GetGamePlayResult = (
    data: any,
    requestSuccess: Function,
    requestError: Function
  ) => {
    // console.log('INTERACT ', this.endpoints.interact)

    if ((window.location.host == "localhost:8080") == false) {
      this.testFakeData = false;
    }

    if (this.testFakeData) {
      let fake = this.fakeDatas[this.fakeDataIndex];

      this.fakeDataIndex++;
      if (this.fakeDataIndex >= this.fakeDatas.length) {
        this.fakeDataIndex = 0;
      }
      // console.log(fake)
      requestSuccess(fake);
      console.log("testData\n", fake);
      return;
    }
    //   else if(this.activeGameData.isEmulation)
    //   {
    //     if(this.activeGameData.emulationMode.selectioneIndex!=undefined)
    //     {
    //       this.emulationData=this.activeGameData.emulationMode.loadNext();
    //       this.activeGameData.betResponse=this.emulationData;
    //        requestSuccess( this.emulationData);
    //       // this.activeGameData.replayFn()
    //     }
    //     else
    //     {
    //         this.activeGameData.clearOnReplayOpenClose();
    //         this.activeGameData.emulationMode.selectFeatureByIndex(0);
    //       return;
    //     }

    //     return;
    // }
    else {
      let self = this;
      Axios({
        method: "post",
        url: this.endpoints.interact,
        data: data,
        timeout: this.timeOut,
        // headers: {'X-Token':'ce007e85-420a-48e2-b0c5-63f08032bec8'}
        headers: { "X-Token": this.token },
      })
        .then(function(response) {
          requestSuccess(response.data);
        })
        .catch(function(error) {
          self.errorHandle(error, requestError);
        });

      this.sendOrientationToGA(data);
    }
  };

  //-------------------

  // public GetGamePlayResult = (data:GamePlayInput,requestSuccess:Function, requestError: Function) => {
  //   let self=this;
  //   Axios({
  //     method: "post",
  //     url: this.endpoints.game,
  //     data: data,
  //     timeout: this.timeOut,
  //     // headers: {'X-Token':'ce007e85-420a-48e2-b0c5-63f08032bec8'}
  //     headers: { "X-Token": this.token },
  //   })
  //     .then(function(response) {
  //       requestSuccess(response.data);
  //     })
  //     .catch(function(error) {
  //       self.errorHandle(error, requestError);
  //     });

  //     this.sendOrientationToGA(data);
  // }

  private sendOrientationToGA = (data: GamePlayInput): void => {
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;
    let OrientationValue = orientationPortrait
      ? "Portrait Mode"
      : "Landscape Mode";

    let DeviceType = this.isMobile ? "Mobile" : "Desktop";

    let betValue = data.value == undefined ? "NOT_APPLICABLE" : data.value;

    const dataToSend = {
      send_to: "G-5P58MJX11R", // "G-CGBKNGE4H8",
      action: data.action,
      brand: this.brand,
      device_type: DeviceType,
      game_id: this.gameId,
      game_mode: this.gameMode,
      game_stake: betValue,
      gameplay_orientation: OrientationValue,
      gameplay_mobileOrientation: this.isMobile ? OrientationValue : "Desktop",
    };
    // console.log(dataToSend)
    gtag("event", "game_action", dataToSend);
  };

  public getInitUrl = (): string => {
    return this.initUrlAfterRequest;
  };
  public GetLoginResult = (
    data: InitializationData,
    requestSuccess: Function,
    requestError: Function
  ) => {
    // let fakeData={}
    //   console.log(fakeData)
    //   requestSuccess(fakeData);
    //   return

    this.initUrlAfterRequest = this.endpoints.login + "?" + jQuery.param(data);

    //--
    let self = this;
    Axios({
      method: "get",
      url: this.initUrlAfterRequest,
      data: {},
      timeout: this.timeOut,

      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
        // console.log(response);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });
  };

  public SetEmulationGameRound = (onSuccess: Function, onFail: Function) => {
    let emulationRoundRequestUrl =
      this.endpoint +
      `/game/emulation-game-round?emulationGameRoundId=${this.activeRoundID}`;

    console.log();
    let self = this;
    Axios({
      method: "post",
      url: emulationRoundRequestUrl,
      data: {},
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        onSuccess(response.data);
        // console.log(response);
      })
      .catch(function(error) {
        self.errorHandle(error, onFail);
      });
  };
  public GetAllEmulationsResult = (
    requestSuccess: Function,
    requestError: Function
  ) => {
    //get all the timestamps and total gamerounds for replay
    let allemulationFeaturesRequestURL =
      this.endpoint + `/game/emulation-game-rounds`; //request emulationRounds
    let self = this;
    Axios({
      method: "get",
      url:
        allemulationFeaturesRequestURL +
        "?" +
        jQuery.param({
          gameReference: this.gameId,
          sortOrder: "desc",
          limit: 1,
        }),
      data: {
        // 'gameReference ':this.gameId, 'sortOrder':'desc','limit':1
      },
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
        // console.log(response);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });
  };

  public GetAllReplaysResult = (
    requestSuccess: Function,
    requestError: Function
  ) => {
    //get all the timestamps and total gamerounds for replay

    let self = this;
    Axios({
      method: "get",
      url:
        this.endpoints.replayRequest +
        "?" +
        jQuery.param({
          gameReference: this.gameId,
          sortOrder: "desc",
          limit: 1,
        }),
      data: {
        // 'gameReference ':this.gameId, 'sortOrder':'desc','limit':1
      },
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
        // console.log(response);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });
  };

  public GetReplayResult = (
    requestSuccess: Function,
    requestError: Function
  ) => {
    //for eachround

    let self = this;
    Axios({
      method: "get",
      url: this.endpoints.replay,
      data: {
        // 'gameReference ':this.gameId, 'sortOrder':'desc','limit':1
      },
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
        // console.log(response);
      })
      .catch(function(error) {
        self.errorHandle(error, requestError);
      });
  };

  public GetJackpotResult = (data: JackpotDto, requestSuccess: Function) => {
    //, requestError: Function) => {

    // let self=this;
    Axios({
      method: "get",
      url: this.endpoints.jackpot + "?" + jQuery.param(data),
      timeout: this.timeOut,
      headers: { "X-Token": this.token },
    })
      .then(function(response) {
        requestSuccess(response.data);
      })
      .catch(function(error) {
        console.log(error);
        // self.errorHandle(error, requestError);
      });

    //--old
    // Axios.get(this.endpoints.jackpot + "?" + jQuery.param(data))
    // .then(function(response: any) {
    //   if (response != undefined) {
    //     requestSuccess(response.data);
    //   }
    // })
    // .catch(function(error) {
    //   console.log(error);
    // });
  };

  //-new tournament
  public GetTournamentScoreOnly = (
    requestSuccess: Function,
    requestError: Function
  ) => {
    this.tournamentAPICalls.GetTournamentScore(requestSuccess, requestError);
  };

  public GetTournamentRanking = (
    data: TournamentDto,
    requestSuccess: Function,
    requestError: Function
  ) => {
    this.tournamentAPICalls.GetTournamentRanking(
      data,
      requestSuccess,
      requestError
    );
  };

  public GetTournamentRegister = (
    requestSuccess: Function,
    requestError: Function
  ) => {
    this.tournamentAPICalls.GetTournamentRegister(requestSuccess, requestError);
  };

  public GetTournamentInfos = (
    requestSuccess: Function,
    requestError: Function
  ) => {
    this.tournamentAPICalls.GetTournamentInfos(requestSuccess, requestError);
  };

  public setSessionID = (newID: string): void => {
    this.token = newID;
    this.tournamentAPICalls.setToken(newID);
    // console.log(this.token)
  };

  public setToken = (newID: string): void => {
    this.token = newID;
    this.tournamentAPICalls.setToken(newID);
    // console.log("game token is replaced with " ,this.token)
  };

  // getters

  public getToken = (): string => {
    return this.token;
  };

  public getOperator = (): string => {
    return this.operator;
  };

  public getEndPoint = (): string => {
    return this.endpoint;
  };
  public getSessionID = (): string => {
    return this.token;
  };

  public getGameId = (): number => {
    return this.gameId;
  };
  public getBrand = (): string => {
    return this.brand;
  };
  //servers actions
  public getServerActions = (): Array<GamePlayInput.ActionEnum> => {
    return this.serverAction;
  };

  public getServerActionBet = (): GamePlayInput.ActionEnum => {
    return this.serverAction[0];
  };

  public getServerActionCollect = (): GamePlayInput.ActionEnum => {
    return this.serverAction[1];
  };

  public getServerActionGamble = (): GamePlayInput.ActionEnum => {
    return this.serverAction[2];
  };

  public getServerActionBonusSpin = (): GamePlayInput.ActionEnum => {
    return this.serverAction[3];
  };

  public getServerActionRecover = (): GamePlayInput.ActionEnum => {
    return this.serverAction[4];
  };

  public getServerActionStakeChange = (): GamePlayInput.ActionEnum => {
    return this.serverAction[5];
  };

  public getServerActionExpandWild = (): GamePlayInput.ActionEnum => {
    return this.serverAction[6];
  };
  public getServerActionRespin = (): GamePlayInput.ActionEnum => {
    return this.serverAction[7];
  };

  public getServerActionExpandBookOfTime = (): GamePlayInput.ActionEnum => {
    return this.serverAction[8];
  };

  public getServerActionBUY_BONUS = (): GamePlayInput.ActionEnum => {
    return this.serverAction[9];
  };
}
